import { useGetThumbnail } from 'hooks/useGetThumbnail';
import { useSelector } from 'hooks/useSelector';
import React from 'react';
import { StyleProp, ViewStyle } from 'react-native';
import { MiniPlan } from 'screens/AssessmentScreen/Repeatable/MiniPlan';
import { selectAssetPlan } from 'store/assets/selectors';

type Props = {
  style?: StyleProp<ViewStyle>;
  assetId: string;
  planId: string;
  x: number;
  y: number;
  maxWidth: number;
  maxHeight: number;
};

export const MiniPlanAsset: React.FC<Props> = ({
  style,
  assetId,
  planId,
  maxWidth,
  maxHeight,
  x,
  y,
}) => {
  const plan = useSelector((state) => selectAssetPlan(state, assetId, planId));
  const fileId = `${plan?.fileId}${plan?.filePage ? `:${plan.filePage}` : ''}`;

  const { image } = useGetThumbnail(fileId) || {
    image: undefined,
  };

  if (!image) {
    return null;
  }

  return (
    <MiniPlan
      style={style}
      image={image}
      x={x}
      y={y}
      maxHeight={maxWidth}
      maxWidth={maxHeight}
    />
  );
};
